import axios from 'axios';

import { IResearchInfrastructureType } from '@/shared/model/research-infrastructure-type.model';

const baseApiUrl = 'api/research-infrastructure-types';

export default class ResearchInfrastructureTypeService {
  public find(id: number): Promise<IResearchInfrastructureType> {
    return new Promise<IResearchInfrastructureType>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieveVisible(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/visible`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}

export { IResearchInfrastructureType };
